<template>
  <div class="content">
    <div class="table-page-operator-wrapper action-btn" >
      <a-button @click="handleTemplate" v-hasPermi="['scp:scpMpsDailySalesDeliveryRatio:template']">下载模版</a-button>
      <a-button @click="$refs.importData.show()" type="primary" v-hasPermi="['scp:scpMpsDailySalesDeliveryRatio:import']"
      >导入</a-button
      >
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:scpMpsDailySalesDeliveryRatio:export']"
      >导出</a-button
      >
    </div>
    <a-spin :spinning="isLoading">
      <ls-api-table
        class="table"
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        rowKey="id"
        :scroll="{ fixScreen: true, x: 1300 }"
      >
        <template slot="dailyForecastOrderRatio" slot-scope="{ record }">
          <span v-if="!isEdit || currentId !== record.id">{{ record.dailyForecastOrderRatio+ '%' }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.id"
            v-model="record.dailyForecastOrderRatio"
            size="small"
          />
        </template>
        <template slot="dailyDeliveryRatio" slot-scope="{ record }">
          <span v-if="!isEdit || currentId !== record.id">{{ record.dailyDeliveryRatio+ '%' }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.id"
            v-model="record.dailyDeliveryRatio"
            size="small"
          />
        </template>
        <template slot="updateTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="createTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="versionCode" slot-scope="{ record }">
          <a @click="handleGoVersion(record)" class="ml10">{{ record.versionCode }}</a>
        </template>
        <!-- 月份 -->
        <template slot="month" slot-scope="{ record, column }">
          <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex].initialDeliveryRatio+ '%' }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.id"
            v-model="record[column.dataIndex].initialDeliveryRatio"
            size="small"
          />
        <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
        </template>
        <!-- 操作 -->
        <span slot="operation" slot-scope="{ record, $index }">
          <a
            v-if="!isEdit || currentId !== record.id"
            @click="handleEdit(record, $index)"
            v-hasPermi="['scp:scpMpsDailySalesDeliveryRatio:edit']">编辑</a
            >
          <!-- <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDelete(typeList, record)">删除</a> -->
          <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
          <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
        </span>
      </ls-api-table>
    </a-spin>
    <import-data
      ref="importData"
      :url="url"
      :mpsBasicDataId="queryParams.mpsBasicDataId"
      @handle-success="handleOk"
    />
  </div>
</template>

  <script>

import { generateLsTableResData } from '@/utils/util.js'
import ImportData from './ImportData'
import { apiScpMpsDailySalesDeliveryRatioList, apiDeleteScpMpsDailySalesDeliveryRatio, apiUpdateScpMpsDailySalesDeliveryRatio } from '@/api/mps/basic-data/basic-data.js'

export default {
  components: {
    ImportData
    },
  props: {
    id: {
      type: String,
      default: '' // 设置默认值为'Hello from child'
    }
  },
  data () {
    const id = this.id
    return {
      isLoading: false,
      url: '/scp/scpMpsDailySalesDeliveryRatio/import',
      isEdit: false,
      tableList: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMpsDailySalesDeliveryRatioList, true),
        pageCurrent: true
      },
      columnsServe: [],
      // 表格字段
      columns: [
        // {
        //   title: '版本',
        //   dataIndex: 'versionCode',
        //   width: 180,
        //   align: 'center'
        // },
        {
          title: '日期',
          dataIndex: 'lineDate',
          width: 120,
          align: 'center'
        },
        {
          title: '日销售比例',
          dataIndex: 'dailyForecastOrderRatio',
          scopedSlots: { customRender: 'dailyForecastOrderRatio' },
          width: 180,
          align: 'center'
        },
        {
          title: '日发货比例',
          dataIndex: 'dailyDeliveryRatio',
          scopedSlots: { customRender: 'dailyDeliveryRatio' },
          width: 180,
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateName',
          width: 120,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 180,
          align: 'center'
        },
        {
          title: '操作',
          fixed: 'right',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 100,
          align: 'center'
        }
      ],
      queryParams: {
        mpsBasicDataId: id
      }
    }
  },
  methods: {
      /** 下载模板操作 */
      handleTemplate () {
      this.download('scp/scpMpsDailySalesDeliveryRatio/template', {
      }, `日销售/发货比例导入模板_${new Date().getTime()}.xlsx`)
    },
        // 接口请求成功后回调
        successCallBack (myDataSource) {
          // debugger
        },
        /** 导出按钮操作 */
   handleExport () {
      this.download('scp/scpMpsDailySalesDeliveryRatio/export', {
        mpsBasicDataId: this.queryParams.mpsBasicDataId
      }, `日销售/发货比例_${new Date().getTime()}.xlsx`)
    },
   // 新增/修改框事件
     handleOk () {
         this.onSearch()
      },
    handleDelete (tableList, record) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          // const ids = []
          // self.columnsServe.forEach((column) => {
          //   console.log(column.indexKey)
          //   const id = record[column.indexKey].id
          //   ids.push(id)
          // })
          apiDeleteScpMpsDailySalesDeliveryRatio(record.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑-保存
    handleSave (record) {
      if (record.dailyForecastOrderRatio < 0) {
        this.$message.warning('日销售比例必须大于等于0')
        return
      }
      if (record.dailyDeliveryRatio < 0) {
        this.$message.warning('日发货比例必须大于等于0')
        return
      }
      const recordCopy = JSON.parse(JSON.stringify(record))
      apiUpdateScpMpsDailySalesDeliveryRatio(recordCopy).then((response) => {
        if (response.code === 200) {
          if (response.data.code === 200) {
            this.$message.success('更新成功')
            this.onSearch()
          } else {
            this.$message.warning(response.data.msg)
            this.onSearch()
          }
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 表单搜索
    onSearch (mpsBasicDataId) {
      this.isEdit = false
      if (mpsBasicDataId) {
        this.queryParams.mpsBasicDataId = mpsBasicDataId;
      }
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
      // this.$refs.dataTable.myPagination.current = 1
      // this.getTableInfo({ sopDfcBasicDataId: this.id, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
    },
    // 编辑
    handleEdit (record, index) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.id
    }
  },
  created () {
  },
  mounted () {
    this.onSearch()
  }
}
</script>

<style scoped lang="less">
.content {
  display: flex;
  flex-direction: column;
}
.action-btn {
  display: flex;
  padding: 8px;
}
.table {
  flex: 1;
}
</style>
